import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SnackAlertService } from 'src/app/services/snack-alert.service';
import { environment } from 'src/environments/environment';
declare let google: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  private returnUrl: string = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly alertService: SnackAlertService
  ) {}

  ngOnInit(): void {
    this.initializeGoogleLogin();
    this.route.queryParams.subscribe((params: any) => {
      console.log(params);
      this.alertService.closeAll();
      if (params.message) {
        this.alertService.openSnackBar(
          "Utente non autorizzato. Per assistenza contattare il team WRP all'indirizzo email: wrp-team@noovle.com",
          'error-snackbar',
          0,
          'Chiudi',
          true
        ); // Aggiunto il parametro showCloseButton
      }
      this.returnUrl = params.returnUrl;
      console.log(this.returnUrl);
    });
  }

  initializeGoogleLogin() {
    google.accounts.id.initialize({
      client_id: environment.clientId,
      callback: this.handleCredentialResponse.bind(Response, this),
    });
    google.accounts.id.renderButton(
      document.getElementById('googleBtn'),
      { theme: 'outline', size: 'medium' } // customization attributes
    );
  }

  handleCredentialResponse(_self: this, response: any) {
    console.log(response);

    localStorage.setItem('currentUser', JSON.stringify(response));

    if (_self.returnUrl) window.location.href = _self.returnUrl;
    else window.location.href = '/';
  }
}
